// Mirror of backend TriggerSendCondition (apps/message_templates/enums.py).
// Shared across features (template form + campaign cadences); the API returns
// only the raw value (e.g. "after"), so labels are resolved here.
export const SEND_CONDITION = Object.freeze({
  AFTER: 'after',
  BEFORE: 'before',
  DAY_OF_MONTH: 'day_of_month',
});

export const SEND_CONDITION_OPTIONS = [
  { value: SEND_CONDITION.AFTER, label: 'After' },
  { value: SEND_CONDITION.BEFORE, label: 'Before' },
  { value: SEND_CONDITION.DAY_OF_MONTH, label: 'Day of month' },
];
